import React from 'react';
import { Box, Typography } from '@mui/material';

const listItemStyle = {
    marginBottom: '0.75rem',
};

const AutoPaySection = () => {
    return (
        <Box sx={{ px: { xs: 2, sm: 4 }, py: 2 }}>
            <Typography paragraph>
                The AutoPay feature, located at the top-right of the Wallet Page, allows users to enable automatic renewal for their subscription plans.
            </Typography>

            {/* Purpose */}
            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
                Purpose
            </Typography>
            <Typography paragraph>
                AutoPay ensures continuous monitoring by automatically renewing expired plans using available wallet balance.
            </Typography>

            {/* How AutoPay Works */}
            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
                How AutoPay Works
            </Typography>
            <ol style={{ paddingLeft: '1.25rem' }}>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        On the day a plan expires, the system checks the user’s wallet balance.
                    </Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        If the balance is sufficient, the plan is renewed automatically.
                    </Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        No user action is needed if AutoPay is enabled.
                    </Typography>
                </li>
            </ol>

            {/* User Control */}
            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
                User Control
            </Typography>
            <ul style={{ paddingLeft: '1.25rem' }}>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        A toggle switch allows the user to turn AutoPay on or off at any time.
                    </Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        Notifications are sent when AutoPay is used to renew a plan.
                    </Typography>
                </li>
            </ul>
            <Typography variant="body1" color="text.secondary" >
                Important: To ensure uninterrupted service, users should maintain sufficient balance in their wallet.
            </Typography>
        </Box>
    );
};

export default AutoPaySection;
